<template>
  <div id="chat">
    <p id="chat-handle" :class="{ live : this.$props.l}">Chat</p>
    <div id="chat-content" :class="{ live : this.$props.l}">
          <button v-on:click="clearChat">Clear chat</button>
      <div id="chat-messages">
        <div>
          <div v-for="(message, index) in messages" v-bind:key="index">
            <div v-if="message.type === 1">
              <span class="other">
                <small>{{message.user}}</small><br>
                {{message.text}}
              </span>
            </div>

            <div v-else>
              <span class="me">
                {{message.text}}
              </span>
            </div>
          </div>

          <small v-if="typing">{{typing}} is typing</small>
          <div
            v-for="(infoItem, index) in info"
            v-bind:key="index"
          >
          </div>
        </div>
      </div>

    <div class="bottom-sticky" v-if="!fold">
      <form @submit.prevent="send">
        <input type="text" v-model="newMessage" placeholder="Enter message here" />
      </form>

      <button v-on:click="send">Send Message</button>
      <!--    <div v-if="this.username == 'host'"> -->
      </div>
    </div>
  </div>
</template>

<script>
import PostService from "../PostService";
import interactions from "../interactions";

export default {
  name: "Chatbox",
  props: {
    username: {
      type: String
    },
    activeRoom: {
      type: Object
    },
    l: {
      type: Boolean
    }
  },

  data() {
    return {
      newMessage: null,
      messages: [],
      typing: false,
      usernm: this.username,
      ready: false,
      info: [],
      connections: 0,
      error: "",
      x: null,
      y: null,
      fold: false,
      formerheight: null,
      ratioLock: false
    };
  },

  mounted() {
    // enable interactions
    interactions.dragDropResize("#chat", "#chat-handle", "#chat-content", this.x, this.y, this.ratioLock);
    interactions.enableFold("#chat-handle", "#chat-content", this.fold);
  },

  updated() {
    let content = document.getElementById("chat-content");
    content.scrollTop = content.scrollHeight;
  },

  async created() {
    this.addUser();
    window.onbeforeunload = () => {
      this.$socket.emit("leave", this.username); // User left the chat
    };

    try {
      const tmpMessages = await PostService.getPosts();
      const thisRoomMessages = tmpMessages.filter( message => message.roomId === this.activeRoom.id)
      this.messages = thisRoomMessages;
    } catch (err) {
      this.error = err.message;
    }
  },

  watch: {
    newMessage(value) {
      const typingValue = {
        username: this.username,
        activeRoom: this.activeRoom,
      }
      value ? this.$socket.emit("typing", typingValue) : this.$socket.emit("stopTyping", typingValue);
    }
  }, // watch

  methods: {
    async sendToDatabase(text) {
      await PostService.insertPost(text);
    },

    async send() {
      // wanneer het bericht niet null is dan mag het verzonden worden 
      if (this.newMessage == null) {
        // console.log(this.newMessage);
      }  
      else {
        // push de data naar this.messages
        this.messages.push({
          text: this.newMessage,
          type: 0,
          user: "Me",
          roomId: this.activeRoom.id
        }); 

        // stuur het via de socket chat-message weg
        this.$socket.emit("chat-message", {
          message: this.newMessage,
          user: this.usernm,
          roomId: this.activeRoom.id
        }); 

        // zet het in een variable om naar de database te sturen
        const txt = {
          text: this.newMessage,
          user: this.usernm,
          type: 1,
          roomId: this.activeRoom.id
        }; 
        // stuur naar de database 
        this.sendToDatabase(txt); 

        // resetmessage 
        this.newMessage = null; 
        this.$socket.emit("getConnections"); // vraag alle socketverbindingen op met andere 
      }

    },

    addUser() {
      this.$socket.emit("joined", this.usernm);
      // this.$socket.emit("getConnections")
    },

    async clearChat() {
      // console.log('clearing chat')
      this.messages.forEach(async message => {
        await PostService.deletePost(message._id);
      });
      this.messages = [];
      this.$socket.emit("updateChat", this.activeRoom.id)
    }
  }, //methods

  sockets: {
    chatMessage: async function(data) {
      if(data.roomId === this.activeRoom.id){    
        this.messages.push({
          text: data.message,
          type: 1,
          user: data.user
        });
      }
    },

    typing: function(data) {
      if(data.activeRoom === this.activeRoom){
        this.typing = data;
      }
    },

    stopTyping: function(data) {
      if(data.activeRoom === this.activeRoom){
        this.typing = false;
      }
    },

    joined: function(data) {
      this.$socket.emit("getConnections");
      this.info.push({
        username: data,
        type: "joined"
      });
      setTimeout(() => {
        this.info = [];
      }, 5000);
    },

    connections: function(data) {
      this.connections = data;
    },

    updateChat: function(data){
      if(data === this.activeRoom.id){
        this.messages = [];
      }
    },

    leave: function(data) {
      this.info.push({
        username: data,
        type: "left"
      });
      setTimeout(() => {
        this.info = [];
      }, 5000);

      this.$socket.emit("getConnections"); // dit werkt nog niet helemaal goed
    }
  } // sockets
};
</script>


<style lang="css">
#chat {
  position:absolute;
  padding: 0;
  z-index: 1000;
}

#chat-content {
  width:200px;
  overflow-y: auto;
  max-height: fit-content !important;
  
  display:flex;
  flex-direction:column;
  justify-content: flex-start;
}

#chat #chat-handle {
  position: sticky;
  border-bottom: 1px solid black;
  top: 0;
  margin: 0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

p#chat-handle {
  font-size: 16px;
  margin-block-start: 0;
  margin-block-end: 5px;
  padding: 5px;
  background-color: #dbfcf0;
}

p#chat-handle.live {
  background-color: #6d6d6d;
}


#chat-content.live button {
  color:rgb(235, 235, 235);
  background-color: #464646;
}

#chat-content.live input {
  color:rgb(235, 235, 235);
  background-color: #464646;
}

#chat-content.live ::placeholder {
  opacity:1;
  color:rgb(235, 235, 235);
}

.card-body {
  position: relative;
}

.other,
.me {
  font-size:max(16px, 1.1vw);
  margin: 0px 10px 10px 10px;
  border: 1px solid black;
  width: 70%;
  overflow-wrap: break-word;
}


.form-group {
  position: relative;
}
.other {
  padding: 7px 10px 10px 10px;
  float: left;
  text-align: left;
  background-color: #c7ffd0;
}
.me {
  padding: 10px 10px 10px 10px;
  text-align: right;
  background-color: #2bf3aa;
  float: right;
}

</style>
